import React from 'react';

const PATHS = {
  governance: (
    <>
      <path d="M9 2h6a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 1-1z" />
      <path d="M9 12.2l1.8 1.8L15 10" />
    </>
  ),
  dlp: (
    <>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </>
  ),
  adoption: (
    <>
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M15 7h6v6" />
    </>
  ),
  agents: (
    <>
      <rect x="6" y="6" width="12" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.4" />
      <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
    </>
  ),
  security: (
    <>
      <path d="M12 2.5l7.5 3.3v5.4c0 4.7-3.2 8-7.5 9.3-4.3-1.3-7.5-4.6-7.5-9.3V5.8L12 2.5z" />
      <path d="M9 12.1l1.9 1.9L15.2 10" />
    </>
  ),
};

export default function CategoryIcon({ categoryKey, size = 18 }) {
  const paths = PATHS[categoryKey];
  if (!paths) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths}
    </svg>
  );
}
